"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var config_context_1 = require("../../_util/config-context");
var i18n_1 = require("../../i18n");
var dropdown_1 = require("../../dropdown");
exports.Loading = function (_a) {
    var offset = _a.offset;
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement(dropdown_1.DropdownBox, { style: { marginLeft: offset } },
        react_1.default.createElement("ul", { className: classPrefix + "-option-list", role: "menu" },
            react_1.default.createElement("li", { role: "presentation", className: "is-disabled" },
                react_1.default.createElement("div", { role: "menuitem", className: classPrefix + "-option-list__item" }, t.loadingText)))));
};
//# sourceMappingURL=Loading.js.map